import { createSelector } from 'reselect';

import { tripSelectors } from 'wanderu-ducks-trips';
import { createSelectorFactory } from 'wanderu-ducks-utils';
import { memoizeOnClient } from 'wanderu-utils';

import { serializeSearchParams } from '../actions/utils';
import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

function _dataSelector(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function _searchResultSelector(state, searchId) {
    const data = _dataSelector(state);
    const psearchData = data[searchId] || {};
    return psearchData.tripIds;
}

const _filterTrips = (tripIds, trips) => tripIds
    .filter((tripId) => !!trips[tripId]).map((tripId) => trips[tripId]);

const filterTrips = memoizeOnClient(_filterTrips, { deep: true });

function _tripsSelector(trips, tripIds) {
    if (!tripIds) {
        return;
    }

    return filterTrips(tripIds, trips);
}

function selectSearchResultsFactory(searchId) {
    return createSelector(
        tripSelectors.selectAllTrips,
        (state) => _searchResultSelector(state, searchId),
        _tripsSelector,
    );
}

const _selectSearchResults = createSelectorFactory(selectSearchResultsFactory);

function selectSearchResults(state, searchParams) {
    const searchId = typeof searchParams === 'string'
        ? searchParams
        : serializeSearchParams(searchParams);

    return _selectSearchResults(state, searchId);
}

function _selectBatchId(state, searchId) {
    const data = _dataSelector(state);
    const psearchData = data[searchId] || {};
    return psearchData.batchId;
}

function selectBatchId(state, searchParams) {
    const searchId = typeof searchParams === 'string'
        ? searchParams
        : serializeSearchParams(searchParams);

    return _selectBatchId(state, searchId);
}

function _selectTripMetadata(state, searchId) {
    const data = _dataSelector(state);
    const psearchData = data[searchId] || {};
    return psearchData.tripMetadata || {};
}

function _selectTripScores(state, searchId) {
    const data = _dataSelector(state);
    const psearchData = data[searchId] || {};

    return psearchData.tripScores || {};
}

function selectTripMetadata(state, searchParams) {
    const searchId = typeof searchParams === 'string'
        ? searchParams
        : serializeSearchParams(searchParams);

    return _selectTripMetadata(state, searchId);
}

function selectTripScores(state, searchParams) {
    const searchId = typeof searchParams === 'string'
        ? searchParams
        : serializeSearchParams(searchParams);

    return _selectTripScores(state, searchId);
}

export {
    selectBatchId,
    selectSearchResults,
    selectTripMetadata,
    selectTripScores,
};
